import UsagePage from './UsagePage';

export default UsagePage;
